export default __webpack_public_path__ + "static/media/the-carlton.49c82473.gif";